import { render, staticRenderFns } from "./MinDonationView.vue?vue&type=template&id=d0a6cd12&"
import script from "./MinDonationView.vue?vue&type=script&lang=js&"
export * from "./MinDonationView.vue?vue&type=script&lang=js&"
import style0 from "./MinDonationView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports